import {
  ClassificationTier,
  getEngagementBadgeProps as getEngagementBadgePropsForTiers,
  getReachBadgeProps,
} from "../classification";

const ENGAGEMENT_TIERS: ClassificationTier[] = [
  { maxFollowers: 10000, tiers: [0.012, 0.036, 0.06, 0.096, 0.2, Infinity] },
  {
    maxFollowers: 50000,
    tiers: [0.00325, 0.00975, 0.01625, 0.026, 0.1, Infinity],
  },
  {
    maxFollowers: 100000,
    tiers: [0.00275, 0.00825, 0.01375, 0.022, 0.1, Infinity],
  },
  {
    maxFollowers: 1000000,
    tiers: [0.0025, 0.0075, 0.0125, 0.02, 0.1, Infinity],
  },
  {
    maxFollowers: Infinity,
    tiers: [0.003, 0.009, 0.015, 0.024, 0.1, Infinity],
  },
];

export const getEngagementBadgeProps = (engagement: number, followers: number) =>
  getEngagementBadgePropsForTiers(engagement, followers, ENGAGEMENT_TIERS);

export { getReachBadgeProps };
